Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node.isRequired,
  hideHorizontalScrollbar: _propTypes2['default'].bool,
  hideVerticalScrollbar: _propTypes2['default'].bool,
  onScroll: _propTypes2['default'].func,
  onScrollDimensionsChange: _propTypes2['default'].func,
  scrollLeft: _propTypes2['default'].number,
  scrollTop: _propTypes2['default'].number
}));

var defaultProps = {
  hideHorizontalScrollbar: false,
  hideVerticalScrollbar: false,
  onScroll: function () {
    function onScroll() {}

    return onScroll;
  }(),
  onScrollDimensionsChange: function () {
    function onScrollDimensionsChange() {}

    return onScrollDimensionsChange;
  }(),

  scrollLeft: 0,
  scrollTop: 0
};

var ScrollContainer = function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  function ScrollContainer(props) {
    _classCallCheck(this, ScrollContainer);

    var _this = _possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props));

    _this.preventScrollEvent = false;

    _this.onScroll = _this.onScroll.bind(_this);
    return _this;
  }

  _createClass(ScrollContainer, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        // Some of these calls force layout, so we want to defer this to avoid
        // layout thrashing.
        this.initialTimeout = setTimeout(function () {
          _this2.initialTimeout = null;
          var _props = _this2.props,
              scrollLeft = _props.scrollLeft,
              scrollTop = _props.scrollTop;

          _this2.setScrollLeft(scrollLeft);
          _this2.setScrollTop(scrollTop);
          _this2.onScrollDimensionsChange();
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _this3 = this;

        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }

        var _props2 = this.props,
            scrollLeft = _props2.scrollLeft,
            scrollTop = _props2.scrollTop;

        var prevScrollLeft = Math.round(prevProps.scrollLeft);
        var prevScrollTop = Math.round(prevProps.scrollTop);
        var scrollDidChange = scrollLeft !== prevScrollLeft || scrollTop !== prevScrollTop;

        // Some of these calls force layout, so we want to defer this to avoid
        // layout thrashing.
        if (scrollDidChange) {
          this.updateTimeout = setTimeout(function () {
            _this3.updateTimeout = null;
            if (scrollLeft !== prevScrollLeft) {
              _this3.setScrollLeft(scrollLeft);
            }
            if (scrollTop !== prevScrollTop) {
              _this3.setScrollTop(scrollTop);
            }

            _this3.onScrollDimensionsChange();
          });
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.initialTimeout) {
          clearTimeout(this.initialTimeout);
        }
        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }
        this.promise = null;
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onScroll',
    value: function () {
      function onScroll(event) {
        if (this.preventScrollEvent) {
          this.preventScrollEvent = false;
          return;
        }

        this.props.onScroll(event);
      }

      return onScroll;
    }()
  }, {
    key: 'onScrollDimensionsChange',
    value: function () {
      function onScrollDimensionsChange() {
        var _containerInner = this.containerInner,
            clientHeight = _containerInner.clientHeight,
            clientWidth = _containerInner.clientWidth,
            scrollHeight = _containerInner.scrollHeight,
            scrollWidth = _containerInner.scrollWidth;


        this.props.onScrollDimensionsChange({
          clientHeight: clientHeight,
          clientWidth: clientWidth,
          scrollHeight: scrollHeight,
          scrollWidth: scrollWidth
        });
      }

      return onScrollDimensionsChange;
    }()
  }, {
    key: 'setScrollLeft',
    value: function () {
      function setScrollLeft(scrollLeft) {
        // setting the `scrollLeft` property would have triggered a `scroll` event;
        // silence the event to avoid an infinite loop of the event setting the prop, etc.
        if (scrollLeft !== this.containerInner.scrollLeft) {
          this.preventScrollEvent = true;
          this.containerInner.scrollLeft = scrollLeft;
        }
      }

      return setScrollLeft;
    }()
  }, {
    key: 'setScrollTop',
    value: function () {
      function setScrollTop(scrollTop) {
        // setting the `scrollTop` property would have triggered a `scroll` event;
        // silence the event to avoid an infinite loop of the event setting the prop, etc.
        if (scrollTop !== this.containerInner.scrollTop) {
          this.preventScrollEvent = true;
          this.containerInner.scrollTop = scrollTop;
        }
      }

      return setScrollTop;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _props3 = this.props,
            css = _props3.css,
            children = _props3.children,
            hideHorizontalScrollbar = _props3.hideHorizontalScrollbar,
            hideVerticalScrollbar = _props3.hideVerticalScrollbar,
            styles = _props3.styles;


        return _react2['default'].createElement(
          'div',
          css(styles.containerOuter, hideHorizontalScrollbar && styles.containerOuter_hideHorizontalScrollbar, hideVerticalScrollbar && styles.containerOuter_hideVerticalScrollbar),
          _react2['default'].createElement(
            'div',
            _extends({}, css(styles.containerInner, hideHorizontalScrollbar && styles.containerInner_hideHorizontalScrollbar, hideVerticalScrollbar && styles.containerInner_hideVerticalScrollbar), {
              onScroll: this.onScroll,
              ref: function () {
                function ref(el) {
                  _this4.containerInner = el;
                }

                return ref;
              }()
            }),
            children
          )
        );
      }

      return render;
    }()
  }]);

  return ScrollContainer;
}(_react2['default'].Component);

ScrollContainer.componentCategory = 'Private';
ScrollContainer.displayName = 'ScrollContainer';


ScrollContainer.propTypes = propTypes;
ScrollContainer.defaultProps = defaultProps;

// This px width is large enough to cover all standard scrollbars
var MAX_SCROLLBAR_WIDTH = 30;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    containerOuter: {
      '-webkit-overflow-scrolling': 'touch',
      height: '100%',
      width: '100%'
    },

    containerOuter_hideHorizontalScrollbar: {
      overflowY: 'hidden'
    },

    containerOuter_hideVerticalScrollbar: {
      overflowX: 'hidden'
    },

    containerInner: {
      height: '100%',
      overflowX: 'auto',
      overflowY: 'auto',
      whiteSpace: 'nowrap'
      // cannot specify `width:100%` because it breaks hideVerticalScrollbar
    },

    containerInner_hideHorizontalScrollbar: {
      // force scrollbar to always show even when not overflowed
      // because we need consistent reserved space to hide
      overflowX: 'scroll',
      // Add enough space to bottom to cover all types of scrollbars
      // then just hide it using overflowY: hidden in this container
      paddingBottom: MAX_SCROLLBAR_WIDTH,
      marginBottom: -MAX_SCROLLBAR_WIDTH
    },

    containerInner_hideVerticalScrollbar: {
      // force scrollbar to always show even when not overflowed
      // because we need consistent reserved space to hide
      overflowY: 'scroll',

      // Add enough space to right to cover all types of scrollbars
      // then just hide it using overflowX: hidden in the container
      paddingRight: MAX_SCROLLBAR_WIDTH,
      marginRight: -MAX_SCROLLBAR_WIDTH,

      // For handling RTL
      paddingLeft: MAX_SCROLLBAR_WIDTH,
      marginLeft: -MAX_SCROLLBAR_WIDTH
    }
  };
})(ScrollContainer);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/ScrollContainer.js
// module id = 154
// module chunks = 923280921217 19843951674672